export default __webpack_public_path__ + "static/media/update_applicant.809ce564.png";